import React from 'react';
import PropostaEmpreendimentoParametroService from '../../../../lib/api/propostaEmpreendimentoParametro/propostaEmpreendimentoParametroService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class PropostaEmpreendimentoParametro extends React.Component<{},{}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametrosUnidadeGerador()
    {
        return PropostaEmpreendimentoParametroService.obterExcel()
    }

    enviarParametrosEventGrid() 
    {
        return PropostaEmpreendimentoParametroService.enviarParametrosAoEventGrid();
    }

    render() 
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametrosUnidadeGerador}
                enviarExcelParametros={PropostaEmpreendimentoParametroService.enviarExcelParametros}
                deletarExcelParametros={PropostaEmpreendimentoParametroService.deletarExcelParametros}
                nomeDoArquivo='Parametro Gerador'
            ></TemplateParametro>
        );
    }
}

export default PropostaEmpreendimentoParametro